import AppContext from "../contexts/AppContext";
import apiFetch from "../helperFunctions/api";
import useAsyncAction from "../helperFunctions/useAsyncAction";
import { useState, useContext } from "react";
import NavBar from "../components/appbar/NavBar";
import { Alert, Button, Typography, TextField, InputAdornment } from "@mui/material";

export default function Manual() {
  const [squishAmount, setSquishAmount] = useState("80");
  const [saved, setSaved] = useState(false);
  const { API, setCharacters } = useContext(AppContext);
  const { pending, error, run } = useAsyncAction();
  const valid = /^\d+$/.test(squishAmount) && Number(squishAmount) <= 100;
  return (
    <>
      <NavBar pageName="Dawnbreaker DKP" />
      <Typography variant="h3">Manual Upload</Typography>
      <Alert severity="info">Manual CSV upload is disabled.</Alert>
      <Typography sx={{ mt: 4 }} variant="h3">DKP Squish</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {saved && <Alert severity="success">DKP squish applied.</Alert>}
      <TextField label="Squish %" value={squishAmount} type="number" disabled={pending}
        error={!valid} helperText={!valid ? "Enter a whole percentage from 0 to 100." : ""}
        onChange={(e) => { setSquishAmount(e.target.value); setSaved(false); }}
        InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }} />
      <Button variant="outlined" disabled={pending || !valid} onClick={() => run(async () => {
        setSaved(false);
        const response = await apiFetch(`${API}/admin/squish`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ squishAmount }),
        });
        setCharacters(await response.json());
        setSaved(true);
      })}>{pending ? "Applying..." : "DKP Squish"}</Button>
    </>
  );
}
